<template>
  <layout>
    <page-header>
      <template slot="header">
        <h4>
          {{ $t('bookings.edit') }}
          <small v-if="booking.number">#{{ booking.number }}</small>
        </h4>
        <div v-if="hasRelatedBooking">
          <button
            class="btn btn-link"
            type="button"
            @click="
              editRelatedBooking(returnBooking ? returnBooking : mainBooking)
            "
          >
            <i class="icon-enter5"></i>
            {{
              isReturnBooking
                ? $t('bookings.edit_main')
                : $t('bookings.edit_return')
            }}
          </button>
        </div>
      </template>
    </page-header>
    <div class="content">
      <b-alert :show="showAlert" :variant="alertType">
        {{ alertText }}
        <hr>
        <a href="#" @click.prevent="closeAlert()">{{ $t('bookings.i_understand') }}</a>
      </b-alert>
      <b-alert v-if="isReturnBooking" show>
        {{ $t('bookings.editing_return') }}
      </b-alert>
      <resource-form
        :id="$route.params.id"
        ref="form"
        :key="$route.params.id"
        @saved="confirmChanges"
        @cancelled="returnBack"
        @loaded="formLoaded"
      />
    </div>
  </layout>
</template>

<script>
import BookingsApi from './Api'
import Edit from '../../../console/src/bookings/Edit'
import ResourceForm from './Form.vue'

const resourceBase = 'bookings'

export default {
  name: 'BookingEdit',

  components: {
    ResourceForm,
  },

  extends: Edit,

  data() {
    return {
      bookingStatusQueryParam: null,
      showAlert: false,
      alertText: '',
      alertType: 'warning',
    }
  },

  mounted() {
    if (this.$route.query['booking-success-alert'] === 'true') {
      this.bookingStatusQueryParam = 'booking-success-alert'
      this.alertText = this.$t('bookings.created_successfully_alert')
      this.alertType = 'info'

    } else if (this.$route.query['payment-cancelled-alert'] === 'true') {
      this.bookingStatusQueryParam = 'payment-cancelled-alert'
      this.alertText = this.$t('bookings.payment_cancelled_alert')
      this.alertType = 'warning'

    } else if (this.$route.query['unable-to-check-payment-alert'] === 'true') {
      this.bookingStatusQueryParam = 'unable-to-check-payment-alert'
      this.alertText = this.$t('bookings.unable_to_check_payment_alert')
      this.alertType = 'warning'

    } else if (this.$route.query['payment-failed-alert'] === 'true') {
      this.bookingStatusQueryParam = 'payment-failed-alert'
      this.alertText = this.$t('bookings.payment_failed_alert')
      this.alertType = 'danger'
    }

    if (this.bookingStatusQueryParam) {
      this.showAlert = true
    }

    // remove auth token from query params
    let queryParams = {...this.$route.query};
    delete queryParams['1351465f-36fe-4f17-b840-e0fcde6ad76a']
    this.$router.replace({query: queryParams})

  },

  methods: {
    api() {
      return new BookingsApi()
    },

    returnBack() {
      this.$router.push({name: `${resourceBase}`})
    },

    questionText(isRefund, diff, currency) {
      return {
        title: this.$t(
          isRefund
            ? 'bookings.messages.new_price_is_less'
            : 'bookings.messages.new_price_is_greater',
        ),
        text:
          this.$t(
            isRefund
              ? 'bookings.messages.do_you_want_to_request_refund_diff'
              : 'bookings.messages.do_you_want_to_pay_diff',
          ) +
          ` (${this.$n(diff, {
            style: 'currency',
            currency: currency.value,
          })})`,
      }
    },

    preconfirmCallback(data) {
      const isRefund = data.amount_diff < 0
      return () => {
        return this.api()
          .createPendingChangesInvoice(data.changes_id)
          .then(({message, data}) => {
            if (isRefund) {
              this.$toast.success(message)
              this.returnBack()
              return
            }
            this.$router.push({
              name: 'orders.pay',
              params: {id: data.id},
            })
          })
      }
    },

    closeAlert() {
      this.showAlert = false
      this.$router.replace({query: {...this.$route.query, [this.bookingStatusQueryParam]: "false"}})
    }
  },
}
</script>
<style>
.media img {
  width: 100px;
}
</style>
